<script>
    import Button from "../Buttons/Button.svelte";

    export let label;
    export let selected;
    export let onClick;
</script>

<style lang="scss">
    @import "../../styles/_mixins.scss";

    .input-container {
        @include input-container;

        :global(button) {
            margin-right: var(--spacer-tiny);
        }

        div {
            height: 44px;
        }
    }

    p {
        @include input-label;
        margin-bottom: var(--spacer-small);
    }
</style>

<div class="input-container">
    <p>{label}</p>
    <div>
        <Button
            primary={selected}
            secondary={!selected}
            text="Yes"
            onClick={() => onClick(true)} />
        <Button
            primary={!selected}
            secondary={selected}
            text="No"
            onClick={() => onClick(false)} />
    </div>
</div>
